/**
 * @flow
 * @format
 */

import React, { PureComponent } from 'react';
import { compose, pure, withState, withHandlers } from 'recompose';
import { get } from 'lodash';
import { OutboundLink } from 'react-ga';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';

import { branch } from '~/utils';
import onSemiLogo from '~/images/onsemifcslogo.svg';
import pswLogo from '~/images/pswlogo.svg';

import StepProgressBar from '../StepProgressBar';
import DesignToolBar from '../DesignToolBar';

import classes from './Header.scss';

type PropsType = {
  currentUser: {},
  showMenu: boolean,
  title: string,
  toggle: Function,
};

export class Header extends PureComponent<PropsType, *> {
  static defaultProps = {
    title: 'Base Design Tool',
    currentUser: {
      username: '',
    },
    showMenu: false,
  };

  props: PropsType;

  render() {
    const { title, showMenu, toggle } = this.props;
    const userName: string = get(this.props, ['currentUser', 'username']);

    const userNameLink = (
      <NavItem>
        <NavLink style={{ color: 'lightgray' }}>{userName}</NavLink>
      </NavItem>
    );

    return (
      <div className={classes.navSticky}>
        <Navbar color="dark" expand="md" dark>
          <NavbarBrand href="/" className={classes.brand}>
            <img
              className="d-none d-lg-inline-flex"
              alt="ON Semi"
              height={40}
              width={120}
              src={onSemiLogo}
            />
            <img
              className="d-none d-lg-inline-flex"
              alt="PS WebDesigner"
              height={40}
              width={220}
              src={pswLogo}
            />
          </NavbarBrand>
          <NavbarBrand>
            <div className="navbar-text inverse" style={{ color: 'lightgray' }}>
              {title}
            </div>
          </NavbarBrand>
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={showMenu} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <OutboundLink
                  to={process.env.REACT_APP_FEEDBACK_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  eventLabel="feedback"
                  className="nav-link"
                  style={{ color: 'lightyellow' }}
                >
                  Feedback
                </OutboundLink>
              </NavItem>
              <NavItem>
                <OutboundLink
                  eventLabel="legal"
                  to={process.env.REACT_APP_LEGAL_LINK}
                  className="nav-link"
                  style={{ color: 'lightgray' }}
                >
                  Legal
                </OutboundLink>
              </NavItem>
              {branch(userName.length > 0, userNameLink)}
              <NavItem>
                <OutboundLink
                  eventLabel="logout"
                  to={process.env.REACT_APP_API_LOGOUT}
                  className="nav-link"
                  style={{ color: 'lightgray' }}
                >
                  Logout
                </OutboundLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
        <DesignToolBar />
        <StepProgressBar />
      </div>
    );
  }
}

// const mapStateToProps = (/* state: AppStateType*/) => ({});
// const connector = connect(mapStateToProps);

const enhancer = compose(
  withState('showMenu', 'setMenu', false),
  // connector,
  withHandlers({
    toggle: ({ setMenu, showMenu }) => () => setMenu(!showMenu),
  }),
  pure,
);
export default enhancer(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js